import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

Vue.prototype.$fetch = async function(url='',data={},signal=undefined){
  if (!data.hash && this.$store && this.$store.state && this.$store.state.hash) {
    data.hash = this.$store.state.hash;
  }
  let response
  try {
    response = await fetch(process.env.VUE_APP_DOMAIN_WEB+"api/v1/"+url, {
      method: 'POST',
      signal,
      //mode: 'no-cors', // no-cors, *cors, same-origin
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });
  } catch (error) {
    // ошибка сети или сервера
    if (error instanceof TypeError){
      this.$setMessage('Net error. try later',false)
      throw content
    }
  }
  const text = await response.text();
  let content
  try {
    content=JSON.parse(text);
  } catch (error) {
    // ошибка полученных данных не v1 версии
    this.$setMessage('Server error. try later',false)
    throw content
  }
    
  if (content.code==3){
    // logout
    this.$store.commit("setHash", null)
    throw content
  }
  if (content.code==4){
    // refresh rights
    // todo: refresh profile + refresh main tick
    this.$setMessage(content.message,false)
    throw content
  }
  if (content.code!=0){
    this.$setMessage(content.message,false)
    throw content
  }
  
  
  return content
}

Vue.prototype.$fetchDownload = async function(url='',data={},signal=undefined,filename=undefined){
  let response
  try {
    response = await fetch(process.env.VUE_APP_DOMAIN_WEB+"api/v1/"+url, {
      method: 'POST',
      signal,
      //mode: 'no-cors', // no-cors, *cors, same-origin
      cache: 'no-cache',
      body: JSON.stringify(data)
    });
  } catch (error) {
    // ошибка сети или сервера
    if (error instanceof TypeError){
      this.$setMessage('Ошибка сети или сервер недоступен, попробуйте повторить операцию позднее',false)
      throw content
    }
  }
  const Hfilename = await response.headers.get('Content-Disposition');
  if (!Hfilename){
    const text = await response.text();
    let content
    try {
      content=JSON.parse(text);
    } catch (error) {
      // ошибка полученных данных не v1 версии
      this.$setMessage('Ошибка сервера, попробуйте повторить операцию позднее',false)
      throw content
    }
      
    if (content.code==3){
      // logout
      this.$store.commit("setHash", null)
      throw content
    }
    if (content.code==4){
      // refresh rights
      // todo: refresh profile + refresh main tick
      this.$setMessage(content.message,false)
      throw content
    }
    if (content.code!=0){
      this.$setMessage(content.message,false)
      throw content
    }
    return content
  }
  const blob = await response.blob();
  var url = window.URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = filename ? filename : Hfilename.split('=')[1];
  document.body.appendChild(a);
  a.click();    
  a.remove(); 
}

Vue.prototype.$hasRight = function(right) {
  if (!store.state.profile)return false
  //return true;
  return store.state.profile.rights.includes(right)
}

Vue.prototype.$setMessage = function(text, isSuccess = true) {
  this.$store.commit("scankbarShow", {
    text,
    color: isSuccess ? "success" : "error",
  })
}

Vue.filter('dateTime', function(value){
  if (!value){
    return ''
  }
  if (value=='9999-01-01 00:00:00')return '∞';
  const date=new Date(value)
  return ("0" + date.getDate()).slice(-2)+'.'+("0" + (date.getMonth()+1)).slice(-2)+'.'+date.getFullYear()+' '+("0" + date.getHours()).slice(-2)+':'+("0" + date.getMinutes()).slice(-2);
})
Vue.filter('yesno', function(value){
  if (value===true){
    return 'Да'
  }
  if (value===false){
    return 'Нет'
  }
})
Vue.filter('onoff', function(value){
  if (value===true){
    return 'Вкл.'
  }
  if (value===false){
    return 'Выкл.'
  }
})
Vue.filter('money', function(number){
  if (typeof number!='string')return '';
  return number.toLocaleString('ru-RU', {
    style: 'currency',
    currency: 'RUB',
  }).replace(',00','');
})
Vue.filter('date', function(value){
  if (!value){
    return ''
  }
  const date=new Date(value.replace(/-/g, "/"))
  return ("0" + date.getDate()).slice(-2)+'.'+("0" + (date.getMonth()+1)).slice(-2)+'.'+date.getFullYear();
})

Vue.filter('plural', function(number,words){
  return number + ' ' +  words[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : [2, 0, 1, 1, 1, 2][number % 10 < 5 ? Math.abs(number) % 10 : 5]
  ]
});

new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
